import http from "../http";
import Service from "../../Service";

/**
 * Análise de Preço do cliente (kyojin GET /clients/reports/price-variation).
 * Substitui o groupBy=cotacaoGroup e o relatorio/variacao/total da api legada.
 */
export default class PriceVariationService extends Service {
    list(params) {
        return http.get("clients/reports/price-variation", {
            headers: this.getHeaders(),
            params,
        });
    }

    requests(search) {
        return http.get("clients/reports/price-variation/requests", {
            headers: this.getHeaders(),
            params: { search: search || undefined },
        });
    }

    export(params) {
        return http.get("clients/reports/price-variation", {
            headers: this.getHeaders(),
            params: { ...params, export: "xlsx" },
            responseType: "blob",
        });
    }
}
